<template>
  <div class="add-wrap">
    <div class="top">
      <el-button type="primary" @click="goback">返回</el-button>
      <el-button type="primary" @click="addModel">保存</el-button>
    </div>
    <div class="box">
      <el-form :rules="rules" ref="modelForm" :model="modelForm" class :inline="true">
        <p class="dialog-title">型号信息</p>
        <el-form-item prop="vehicleModel" label="车辆型号">
          <el-input v-model="modelForm.vehicleModel" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="modelCode" label="车辆编码">
          <el-input v-model="modelForm.modelCode" placeholder="请输入"></el-input>
        </el-form-item>
        <p class="dialog-title">生产企业信息</p>
        <el-form-item prop="vehicleName" label="车辆名称">
          <el-input v-model="modelForm.vehicleName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="brand" label="中文品牌">
          <el-input v-model="modelForm.brand" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="noticeModel" label="公告型号">
          <el-input v-model="modelForm.noticeModel" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="enterpriseName" label="企业名称">
          <el-input v-model="modelForm.enterpriseName" placeholder="请输入"></el-input>
        </el-form-item>
        <p class="dialog-title">主要技术参数</p>
        <div :gutter="20" class="size">
          <div class="long-label">
            <el-form-item prop="length" label="外形尺寸(mm)">
              <el-input v-model="modelForm.length" placeholder="长"></el-input>
            </el-form-item>
          </div>
          <div class="size-box">
            <el-form-item prop="wide" label="×">
              <el-input v-model="modelForm.wide" placeholder="宽"></el-input>
            </el-form-item>
          </div>
          <div class="size-box">
            <el-form-item prop="high" label="×">
              <el-input v-model="modelForm.high" placeholder="高"></el-input>
            </el-form-item>
          </div>
        </div>

        <el-form-item prop="totalQuality" label="总质量(kg)">
          <el-input v-model="modelForm.totalQuality" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="wholeQuality" label="整备质量(kg)">
          <el-input v-model="modelForm.wholeQuality" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="ratedPassenger" label="额定载客(人)">
          <el-input v-model="modelForm.ratedPassenger" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="wheelbase" label="轴距(mm)">
          <el-input v-model="modelForm.wheelbase" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="maSpeed" label="最高车速(km/h)">
          <el-input v-model="modelForm.maSpeed" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="axleNumber" label="轴数">
          <el-input v-model="modelForm.axleNumber" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="springNumber" label="弹簧片数">
          <el-input v-model="modelForm.springNumber" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="tyreNumber" label="轮胎数">
          <el-input v-model="modelForm.tyreNumber" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="tyreSpecs" label="轮胎规格">
          <el-input v-model="modelForm.tyreSpecs" placeholder="请输入"></el-input>
        </el-form-item>

        <p class="dialog-title">发动机参数</p>
        <el-form-item prop="engine" label="发动机">
          <el-input v-model="modelForm.engine" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="engineCreateEnterprise" label="发动机生产企业">
          <el-input v-model="modelForm.engineCreateEnterprise" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item class="long-input" prop="displacement" label="排量(ml)">
          <el-input v-model="modelForm.displacement" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item class="long-input" prop="power" label="功率(kw)">
          <el-input v-model="modelForm.power" placeholder="请输入"></el-input>
        </el-form-item>
        <p class="dialog-title">车辆燃料参数</p>
        <el-form-item prop="fuelTypes" label="燃料类型">
          <el-select v-model="modelForm.fuelTypes" clearable placeholder="请选择">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="basisStandard" label="依据标准">
          <el-input v-model="modelForm.basisStandard" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="chassisLetoutStand" label="底盘排放标准">
          <el-select v-model="modelForm.chassisLetoutStand" clearable placeholder="请选择">
            <el-option
              v-for="item in dischargeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddModel',
  props: {
    editTag: {
      type: String,
      required: true
    },
    modelForm: {
      type: Object,
      required: true
    },
  },
  data () {
    return {

      rules: {
        vehicleModel: [
          { required: true, trigger: "change", message: "请输入车辆型号" }
        ],
        modelCode: [
          { required: true, trigger: "change", message: "请输入车辆编码" }
        ],
        vehicleName: [
          { required: true, trigger: "change", message: "请输入车辆名称" }
        ],
        brand: [
          { required: true, trigger: "change", message: "请输入中文品牌" }
        ],
        noticeModel: [
          { required: true, trigger: "change", message: "请输入公告型号" }
        ],
        enterpriseName: [
          { required: true, trigger: "change", message: "请输入企业名称" }
        ],
        length: [
          { required: true, trigger: "change", message: "请输入长度" },
          { pattern: this.$formRules.num, trigger: "blur", message: this.$formRules.numMsg }
        ],
        wide: [
          { required: true, trigger: "change", message: "请输入宽度" },
          { pattern: this.$formRules.num, trigger: "blur", message: this.$formRules.numMsg }
        ],
        high: [
          { required: true, trigger: "change", message: "请输入高度" },
          { pattern: this.$formRules.num, trigger: "blur", message: this.$formRules.numMsg }
        ],
        totalQuality: [
          { required: true, trigger: "change", message: "请输入总质量" },
          { pattern: this.$formRules.twoDecimal, trigger: "blur", message: this.$formRules.twoDecimalMsg }
        ],
        wholeQuality: [
          { required: true, trigger: "change", message: "请输入整备质量" },
          { pattern: this.$formRules.twoDecimal, trigger: "blur", message: this.$formRules.twoDecimalMsg }
        ],
        ratedPassenger: [
          { required: true, trigger: "change", message: "请输入额定载客" },
          { pattern: this.$formRules.num, trigger: "blur", message: this.$formRules.numMsg }
        ],
        wheelbase: [
          { required: true, trigger: "change", message: "请输入轴距" },
          { pattern: this.$formRules.twoDecimal, trigger: "blur", message: this.$formRules.twoDecimalMsg }
        ],
        maSpeed: [
          { required: true, trigger: "change", message: "请输入最高车速" },
          { pattern: this.$formRules.twoDecimal, trigger: "blur", message: this.$formRules.twoDecimalMsg }
        ],
        axleNumber: [
          { required: true, trigger: "change", message: "请输入轴数" },
          { pattern: this.$formRules.num, trigger: "blur", message: this.$formRules.numMsg }
        ],
        springNumber: [
          { required: true, trigger: "change", message: "请输入弹簧片数" },
          { pattern: this.$formRules.num, trigger: "blur", message: this.$formRules.numMsg }
        ],
        tyreNumber: [
          { required: true, trigger: "change", message: "请输入轮胎数" },
          { pattern: this.$formRules.num, trigger: "blur", message: this.$formRules.numMsg }
        ],
        tyreSpecs: [
          { required: true, trigger: "change", message: "请输入轮胎规格" }
        ],
        engine: [
          { required: true, trigger: "change", message: "请输入发动机" }
        ],
        engineCreateEnterprise: [
          { required: true, trigger: "change", message: "请输入发动机生产企业" }
        ],
        displacement: [
          { required: true, trigger: "change", message: "请输入排量" },
          { pattern: this.$formRules.twoDecimal, trigger: "blur", message: this.$formRules.twoDecimalMsg }
        ],
        power: [
          { required: true, trigger: "change", message: "请输入功率" },
          { pattern: this.$formRules.twoDecimal, trigger: "blur", message: this.$formRules.twoDecimalMsg }
        ],
        fuelTypes: [
          { required: true, trigger: "change", message: "请选择燃料类型" }
        ],
        basisStandard: [
          { required: true, trigger: "change", message: "请输入依据标准" }
        ],
        chassisLetoutStand: [
          { required: true, trigger: "change", message: "请选择底盘排放标准" }
        ],
      },
      typeList: [
        {
          name: "汽油",
          value: 1
        },
        {
          name: "柴油",
          value: 2
        }, {
          name: "电动",
          value: 3
        }, {
          name: "混动",
          value: 4
        }
      ],
      dischargeList: [
        {
          name: "国一",
          value: 1
        },
        {
          name: "国二",
          value: 2
        }, {
          name: "国三",
          value: 3
        }, {
          name: "国四",
          value: 4
        }, {
          name: "国五",
          value: 5
        }, {
          name: "国六",
          value: 6
        }
      ],
    }
  },
  methods: {
    goback () {
      this.$emit('child-change', true)
    },

    addModel () {
      this.saveOrUpdate()
    },
    saveOrUpdate () {
      let _this = this;
      let data = []
      _this.$refs.modelForm.validate(async valid => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post('/api/vehicle/model', _this.modelForm);
          } else {
            data = await _this.$axios.patch('/api/vehicle/model', _this.modelForm);
          }
          let res = data.data
          if (res.code == 1) {
            //信息提示
            _this.$message.success('操作成功');
            //刷新表格
            this.$emit('child-change', true)
            _this.modelForm = {}
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.add-wrap {
  height: 100%;
}
.top {
  height: 48px;
  line-height: 48px;
  display: block;
  margin-bottom: 20px;
  padding-left: 20px;
  background-color: #fff;
}
.box {
  height: calc(100% - 108px);
  overflow-y: auto;
  background: #fff;
  padding: 20px;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
@media screen and (min-width: 1584px) {
  .box /deep/ .el-form > div {
    width: 32%;
  }
}
@media screen and (max-width: 1584px) {
  .box /deep/ .el-form > div {
    width: 49%;
  }
}
.size /deep/ .el-form-item__error {
  width: 72px;
}
.size-box /deep/ {
  .el-form-item__label::before {
    content: "" !important;
    margin-right: 0 !important;
  }
  .el-form-item__label {
    font-size: 32px;
    text-align: center;
  }
}

.box /deep/ {
  .el-form .el-form-item__label {
    width: 132px;
    padding-left: 10px;
    text-align: left;
  }
  .el-form .el-form-item__content {
    width: 260px;
  }
  .size {
    margin-right: 10px;
    display: inline-block;
    .el-form-item__content {
      width: 73px;
    }
    .long-label {
      display: inline-block;
      .el-form-item__label {
        width: 132px;
        padding-left: 10px;
        text-align: left;
      }
    }
    .size-box {
      display: inline-block;
      width: 93px;
    }
    .el-form-item__label {
      width: 20px;
      padding: 0;
    }
    .el-form-item {
      margin-right: 0 !important;
    }
  }
}
</style>